/**
 * Распределяет totalBudget по позициям по процентам.
 * Округление может дать лишние кристаллы — убираем с нижних тиров (последние в массиве).
 */
export function distributeCrystalBudgets(budgetPercents, totalBudget) {
    if (!budgetPercents?.length) return [];

    const amounts = budgetPercents.map((percent) =>
        Math.round((Number(percent) / 100) * totalBudget)
    );

    let diff = amounts.reduce((sum, value) => sum + value, 0) - totalBudget;

    if (diff === 0) return amounts;

    let index = amounts.length - 1;
    while (diff !== 0 && index >= 0) {
        if (diff > 0) {
            if (amounts[index] > 0) {
                amounts[index] -= 1;
                diff -= 1;
            } else {
                index -= 1;
            }
        } else {
            amounts[index] += 1;
            diff += 1;
            index -= 1;
        }
    }

    return amounts;
}

export function buildCrystalPositions(presets, totalBudget, totalPlaces) {
    if (!presets?.length) return [];

    const budgetPercents = presets.map((preset) => preset.budget_percent || 0);
    const budgets = distributeCrystalBudgets(budgetPercents, totalBudget);

    return presets.map((preset, index) => {
        const winners = Math.round((preset.win / 100) * totalPlaces);
        const budgetAmount = budgets[index];
        const dropPerWinner = winners > 0 ? Math.round(budgetAmount / winners) : 0;

        return {
            winPercent: preset.win || 0,
            winners,
            budgetPercent: preset.budget_percent || 0,
            budget: budgetAmount,
            dropPerWinner,
        };
    });
}
